import './competitors.scss';

import generateRandomGibberish from '../../shared/generateGibberish';
import { dispatchEvent } from '../../shared/events';

class _Controller {
  constructor($resultsStore, $domainSearchSettings, UserService) {
    this.results = $resultsStore;
    this.$domainSearchSettings = $domainSearchSettings;
    this.paddedResults = [];
    this.isFreeUser = UserService.user.isFreeUser;
  }

  $onInit() {
    this.padResults();
  }

  padResults() {
    if (this.isFreeUser) {
      for (let i = 0; i < 15; i++) {
        const paddedPhrase = generateRandomGibberish(1, 12, 25);
        this.paddedResults.push({competitor: paddedPhrase, number: Math.floor(Math.random() * 8000) + 60});
      }
    }
  }

  clickedDisabledCompetitor() {
    dispatchEvent('clickedGetMoreCompetitors');
  }
}

_Controller.$inject = ['$resultsStore', '$domainSearchSettings', 'UserService'];

export const competitors = {
  bindings: {
    onClickResultFn: '&'
  },
  controller: _Controller,
  template: require('./competitors.html')
}
